import React from 'react';
import { Tooltip } from '@mui/material';

/**
 * The whole of a post's text on hover, for a name cut short in a table cell (2026-10-18).
 *
 * The browser's own `title` tooltip was used before: slow to appear, unstyled, and in the X cost
 * table it only had the first 80 characters to show. Line breaks are kept, and the width is capped
 * so a long Instagram caption reads as a paragraph rather than one line across the screen.
 */
export const FullTextTooltip: React.FC<{ text: string | null | undefined; children: React.ReactElement }> = ({ text, children }) =>
  text ? (
    <Tooltip
      title={<span style={{ whiteSpace: 'pre-wrap' }}>{text}</span>}
      placement="top-start"
      enterDelay={250}
      slotProps={{ tooltip: { sx: { maxWidth: 440, fontSize: 13, lineHeight: 1.45 } } }}
    >
      {children}
    </Tooltip>
  ) : children;
